// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MojaMentorstvaVoditelj_groupHeadContainerMentorships__cKv3M {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px 0px;
}
.MojaMentorstvaVoditelj_groupHeadTextContainerMentorships__izpqx {
  row-gap: 8px;
}
.MojaMentorstvaVoditelj_groupTitleMentorships__hop7g {
  color: #4d4d4d;
  font-size: 28px;
  line-height: normal;
  letter-spacing: -0.028px;
}
.MojaMentorstvaVoditelj_groupHeadTextContainerMentorships__izpqx,
.MojaMentorstvaVoditelj_groupTitleMentorships__hop7g,
.MojaMentorstvaVoditelj_groupDateTextMentorships__IoLjH {
  cursor: default;
}
.MojaMentorstvaVoditelj_groupTitleMentorships__hop7g,
.MojaMentorstvaVoditelj_groupDateTextMentorships__IoLjH,
.MojaMentorstvaVoditelj_saveButtonText__7CBr7,
.MojaMentorstvaVoditelj_cancelButtonText__8dCSe {
  font-family: Inter;
  font-weight: 600;
  margin: 0px;
}
.MojaMentorstvaVoditelj_groupDateTextMentorships__IoLjH {
  color: #818c99;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.MojaMentorstvaVoditelj_tableWrapper__GKKpZ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.MojaMentorstvaVoditelj_containerTableAttendees__QoaFw,
.MojaMentorstvaVoditelj_attendeesContainer__vuuUH,
.MojaMentorstvaVoditelj_groupHeadTextContainerMentorships__izpqx {
  display: flex;
  flex-direction: column;
}
.MojaMentorstvaVoditelj_attendeesContainer__vuuUH {
  margin: 53px 0px 40px;
  row-gap: 24px;
}
.MojaMentorstvaVoditelj_editActionsButtons__t789P {
  width: 100%;
}
.MojaMentorstvaVoditelj_editActionsButtons__t789P,
.MojaMentorstvaVoditelj_editModeButtonscontainer__uBMYy,
.MojaMentorstvaVoditelj_saveButton__eKmQN,
.MojaMentorstvaVoditelj_cancelButton__lJUoF {
  display: flex;
  justify-content: center;
}
.MojaMentorstvaVoditelj_saveButton__eKmQN,
.MojaMentorstvaVoditelj_cancelButton__lJUoF {
  background-color: #cb9c2d;
  border-radius: 4px;
  height: 52px;
  width: 212px;
  align-items: center;
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.MojaMentorstvaVoditelj_saveButtonText__7CBr7 {
  color: #ffffff;
  text-transform: capitalize;
}
.MojaMentorstvaVoditelj_saveButtonText__7CBr7,
.MojaMentorstvaVoditelj_cancelButtonText__8dCSe {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.MojaMentorstvaVoditelj_saveButton__eKmQN:hover {
  background-color: #b98d26;
}
.MojaMentorstvaVoditelj_cancelButton__lJUoF {
  background-color: #ebebeb;
  border-radius: 4px;
  height: 52px;
  width: 212px;
}
.MojaMentorstvaVoditelj_cancelButton__lJUoF:hover {
  background-color: #c7c6c6;
}
.MojaMentorstvaVoditelj_cancelButtonText__8dCSe {
  color: #808080;
}
.MojaMentorstvaVoditelj_resultsTextMentorships__pETd6 {
  margin-top: 40px;
  color: #4d4d4d;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.02px;
}
.MojaMentorstvaVoditelj_selectContainer__0u1IO {
  display: flex;
  flex-direction: row;
  width: 80%;
  gap: 24px;
  margin-bottom: 40px;
}
.MojaMentorstvaVoditelj_selectDropdowns__0KlOM {
  width: 50%;
}
.MojaMentorstvaVoditelj_containerTableAttendees__QoaFw {
  margin-top: 66px;
  gap: 24px;
}
.MojaMentorstvaVoditelj_editModeButtonscontainer__uBMYy {
  gap: 16px;
  width: 100%;
  margin-bottom: 30px;
}
.MojaMentorstvaVoditelj_backRow__0mgin {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  cursor: pointer;
}
.MojaMentorstvaVoditelj_back__\\+YHtq {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: #5f6d7e;
  transition: -webkit-text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out, -webkit-text-decoration 300ms ease-in-out;
}
.MojaMentorstvaVoditelj_back__\\+YHtq:hover {
  text-decoration: underline;
  cursor: pointer;
}
.MojaMentorstvaVoditelj_arrow__fQl-E {
  cursor: pointer;
}
.MojaMentorstvaVoditelj_emptyContainer__SuGW0 {
  color: #5f6d7e;
  font-family: Inter;
  font-style: normal;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 34px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  background-color: #fcfcfc;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  box-sizing: border-box;
  justify-content: space-between;
  margin-bottom: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/voditelji/components/MojaMentorstvaVoditelj.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;;;EAGE,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,aAAa;EACb,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,qDAA6C;EAA7C,6CAA6C;EAA7C,wFAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oDAAoD;EACpD,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".groupHeadContainerMentorships {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 24px 0px;\n}\n.groupHeadTextContainerMentorships {\n  row-gap: 8px;\n}\n.groupTitleMentorships {\n  color: #4d4d4d;\n  font-size: 28px;\n  line-height: normal;\n  letter-spacing: -0.028px;\n}\n.groupHeadTextContainerMentorships,\n.groupTitleMentorships,\n.groupDateTextMentorships {\n  cursor: default;\n}\n.groupTitleMentorships,\n.groupDateTextMentorships,\n.saveButtonText,\n.cancelButtonText {\n  font-family: Inter;\n  font-weight: 600;\n  margin: 0px;\n}\n.groupDateTextMentorships {\n  color: #818c99;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.tableWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n}\n.containerTableAttendees,\n.attendeesContainer,\n.groupHeadTextContainerMentorships {\n  display: flex;\n  flex-direction: column;\n}\n.attendeesContainer {\n  margin: 53px 0px 40px;\n  row-gap: 24px;\n}\n.editActionsButtons {\n  width: 100%;\n}\n.editActionsButtons,\n.editModeButtonscontainer,\n.saveButton,\n.cancelButton {\n  display: flex;\n  justify-content: center;\n}\n.saveButton,\n.cancelButton {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  height: 52px;\n  width: 212px;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.saveButtonText {\n  color: #ffffff;\n  text-transform: capitalize;\n}\n.saveButtonText,\n.cancelButtonText {\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.saveButton:hover {\n  background-color: #b98d26;\n}\n.cancelButton {\n  background-color: #ebebeb;\n  border-radius: 4px;\n  height: 52px;\n  width: 212px;\n}\n.cancelButton:hover {\n  background-color: #c7c6c6;\n}\n.cancelButtonText {\n  color: #808080;\n}\n.resultsTextMentorships {\n  margin-top: 40px;\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.02px;\n}\n.selectContainer {\n  display: flex;\n  flex-direction: row;\n  width: 80%;\n  gap: 24px;\n  margin-bottom: 40px;\n}\n.selectDropdowns {\n  width: 50%;\n}\n.containerTableAttendees {\n  margin-top: 66px;\n  gap: 24px;\n}\n.editModeButtonscontainer {\n  gap: 16px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n.backRow {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 16px;\n  cursor: pointer;\n}\n.back {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n  transition: text-decoration 300ms ease-in-out;\n}\n.back:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.arrow {\n  cursor: pointer;\n}\n.emptyContainer {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-style: normal;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 34px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  background-color: #fcfcfc;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  box-sizing: border-box;\n  justify-content: space-between;\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupHeadContainerMentorships": `MojaMentorstvaVoditelj_groupHeadContainerMentorships__cKv3M`,
	"groupHeadTextContainerMentorships": `MojaMentorstvaVoditelj_groupHeadTextContainerMentorships__izpqx`,
	"groupTitleMentorships": `MojaMentorstvaVoditelj_groupTitleMentorships__hop7g`,
	"groupDateTextMentorships": `MojaMentorstvaVoditelj_groupDateTextMentorships__IoLjH`,
	"saveButtonText": `MojaMentorstvaVoditelj_saveButtonText__7CBr7`,
	"cancelButtonText": `MojaMentorstvaVoditelj_cancelButtonText__8dCSe`,
	"tableWrapper": `MojaMentorstvaVoditelj_tableWrapper__GKKpZ`,
	"containerTableAttendees": `MojaMentorstvaVoditelj_containerTableAttendees__QoaFw`,
	"attendeesContainer": `MojaMentorstvaVoditelj_attendeesContainer__vuuUH`,
	"editActionsButtons": `MojaMentorstvaVoditelj_editActionsButtons__t789P`,
	"editModeButtonscontainer": `MojaMentorstvaVoditelj_editModeButtonscontainer__uBMYy`,
	"saveButton": `MojaMentorstvaVoditelj_saveButton__eKmQN`,
	"cancelButton": `MojaMentorstvaVoditelj_cancelButton__lJUoF`,
	"resultsTextMentorships": `MojaMentorstvaVoditelj_resultsTextMentorships__pETd6`,
	"selectContainer": `MojaMentorstvaVoditelj_selectContainer__0u1IO`,
	"selectDropdowns": `MojaMentorstvaVoditelj_selectDropdowns__0KlOM`,
	"backRow": `MojaMentorstvaVoditelj_backRow__0mgin`,
	"back": `MojaMentorstvaVoditelj_back__+YHtq`,
	"arrow": `MojaMentorstvaVoditelj_arrow__fQl-E`,
	"emptyContainer": `MojaMentorstvaVoditelj_emptyContainer__SuGW0`
};
export default ___CSS_LOADER_EXPORT___;
